import React from 'react';

import styles from './cookieBannerPanelActionArea.scss';

interface CookieBannerPanelActionAreaProps {
  children: React.ReactNode;
}

function CookieBannerPanelActionArea({
  children
}: CookieBannerPanelActionAreaProps) {
  return <div className={styles.wrapper}>{children}</div>;
}

export default CookieBannerPanelActionArea;
